import { getSchedulePosts, getSchedulesList, getScheduleByDay } from './schedule'

export default { getSchedulePosts, getSchedulesList, getScheduleByDay }
